import { makeObservable, observable, action } from "mobx";

class FilterSortStore {
  sortBy = "name";
  sortDirection = "asc";

  constructor() {
    makeObservable(this, {
      sortBy: observable,
      sortDirection: observable,
      setSortBy: action
    });
  }

  setSortBy = (field) => {
    if (this.sortBy === field) {
      this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
    } else {
      this.sortBy = field;
      this.sortDirection = "asc";
    }
  };

  sortItems = (items) => {
    return items.slice().sort((a, b) => {
      const direction = this.sortDirection === "asc" ? 1 : -1;
      
      switch (this.sortBy) {
        case "name":
          const titleA = a.title || a.name || '';
          const titleB = b.title || b.name || '';
          return direction * titleA.localeCompare(titleB);
        case "lastUpdated":
          const dateA = a.lastUpdated ? new Date(a.lastUpdated) : 
                       a.updated_at ? new Date(a.updated_at) : new Date(0);
          const dateB = b.lastUpdated ? new Date(b.lastUpdated) : 
                       b.updated_at ? new Date(b.updated_at) : new Date(0);
          return direction * (dateA - dateB);
        default:
          return 0;
      }
    });
  };
}

export default FilterSortStore;